import { render } from "./App.vue?vue&type=template&id=78b6900b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=78b6900b&lang=css"

import exportComponent from "/Users/masayukitenma/Documents/Develop/Container/claudedocs/l13-check/fe-build/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__